<template>
  <v-dialog
    v-model="dialog"
    :max-width="modalMaxWidth"
    persistent
    scrollable
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>{{ stand && stand.placeName ? stand.placeName : 'Pabellón' }}</span>
        <v-btn
          icon
          @click="closeModal"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <div v-if="isLoadingPlace" class="d-flex justify-center align-center" style="height: 200px;">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <div v-else>
          <div v-if="placeImageUrl">
            <v-img
              :src="placeImageUrl"
              :max-height="maxImageHeight"
              contain
              class="rounded"
              @load="onImageLoad"
              @error="onImageError"
            >
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular indeterminate color="primary" />
                </div>
              </template>
            </v-img>
          </div>
          <div v-else class="text-center pa-4">
            <v-img
              :src="notImage"
              aspect-ratio="16/9"
              contain
              class="rounded"
              :max-height="200"
            />
            <p class="mt-2 text-grey">No hay imagen disponible para este pabellón</p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import crudServiceMixin from '@/mixins/crudServiceMixin'
import { PUBLIC_PLACE_URL } from '@/constants/ServicesConstants'

export default {
  name: 'StandModal',
  mixins: [crudServiceMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    stand: {
      type: Object,
      default: null
    },
    fairId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      place: null,
      isLoadingPlace: false,
      imageLoaded: false,
      imageError: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    placeImageUrl () {
      const imagePath = this.place && this.place.appPlaneImageUrl ? this.place.appPlaneImageUrl : null
      const baseUrl = process.env.VUE_APP_API_IMAGES_URL
      if (imagePath && baseUrl) {
        const cleanBaseUrl = baseUrl.replace(/\/$/, '')
        const cleanImagePath = imagePath.replace(/^\//, '')
        return `${cleanBaseUrl}/${cleanImagePath}`
      }
      return ''
    },
    modalMaxWidth () {
      if (this.$vuetify.breakpoint.xs) return '95vw'
      if (this.$vuetify.breakpoint.sm) return '90vw'
      if (this.$vuetify.breakpoint.md) return '80vw'
      return '900px'
    },
    maxImageHeight () {
      if (this.$vuetify.breakpoint.xs) return '70vh'
      if (this.$vuetify.breakpoint.sm) return '65vh'
      return '600px'
    },
    notImage () {
      const resourceDir = process.env.VUE_APP_FAIR_RESOURCES_DIRECTORY || 'default'
      const notImagePath = `/img/icons/${resourceDir}/not-image.jpg`
      return notImagePath
    }
  },
  watch: {
    stand: {
      handler (newStand) {
        if (newStand && newStand.placeName && this.fairId) {
          this.fetchPlaceDetails()
        } else {
          this.place = null
        }
      },
      immediate: true
    }
  },
  methods: {
    async fetchPlaceDetails () {
      if (!this.stand || !this.stand.placeName || !this.fairId) {
        return
      }
      this.isLoadingPlace = true
      this.place = null
      try {
        const url = PUBLIC_PLACE_URL + '/all'
        const params = { fairId: this.fairId }
        const response = await this.get(url, { params })
        const places = response.data
        const targetPlaceName = this.stand.placeName.trim().toLowerCase()
        this.place = places.find(p =>
          p.name.trim().toLowerCase() === targetPlaceName
        ) || null
      } catch (error) {
        this.place = null
      } finally {
        this.isLoadingPlace = false
      }
    },
    closeModal () {
      this.dialog = false
    },
    onImageLoad () {
      this.imageLoaded = true
      this.imageError = false
    },
    onImageError (error) {
      this.imageError = true
      this.imageLoaded = false
      console.error('Image failed to load:', this.placeImageUrl, error)
    }
  }
}
</script>

<style scoped>
.v-card-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.v-dialog {
  max-height: 95vh;
}

@media (max-width: 600px) {
  .v-card-text {
    padding: 8px !important;
  }
}

.v-image {
  width: 100% !important;
}
</style>
